<template>
  <TableCommon
    title="客户关系"
    :custome-config="() => vxeShowCustom('xTable3')"
  >
    <vxe-grid
      ref="xTable3"
      class="table-block"
      border
      :highlight-hover-row="true"
      resizable
      :show-overflow="true"
      height="300"
      max-height="500"
      align="center"
      size="mini"
      :empty-render="{name: 'NotData'}"
      :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      :columns="gridOptions.columns"
      :data="gridOptions.data"
    />
  </TableCommon>
</template>

<script>
export default {
  props: {
    relation: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gridOptions: {
        columns: [
          {
            field: 'RELTYP_TEXT',
            title: '关系类型'
          },
          { field: 'PARTNER2', title: '关系客户' },
          { field: 'NAME_ORG1', title: '客户描述' },
          { field: 'PHONE', title: '电话' }
        ],
        data: []
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.gridOptions.data = this.relation
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/client-manage/components/ClientRelationCheck.vue